'use client';

import { LazyMotion } from 'framer-motion';

import features from './features';

export type MotionLazyProps = {
  children: React.ReactNode;
};

export function MotionLazy({ children }: MotionLazyProps) {
  return (
    <LazyMotion strict features={features}>
      {children}
    </LazyMotion>
  );
}
